import { HttpStatus } from '../types';
import { AppError, ErrorTypes } from './app.error';

export class InternalServerError extends AppError {
    constructor(detail?: string, rest?: { [key: string]: unknown }) {
        super({
            status: HttpStatus.INTERNAL_SERVER_ERROR,
            type: ErrorTypes.INTERNAL_SERVER_ERROR,
            title: 'Internal Server Error',
            detail,
            ...rest,
        });
    }
}
